import './flash.scss';

import { func, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Table } from 'reactstrap';

import { revealLine } from '../../campaign-editor/actions';
import highlight from './highlight';
import { getErrorTargetId, linearize } from './utils';

const BORDER_RED = 'border-red';

function scrollAnchor(path, linkTarget, reveal) {
  if (!linkTarget) {
    return path;
  }
  const id = getErrorTargetId(linkTarget.type, linkTarget.id);
  const target = document.getElementById(id);
  target?.classList.add(BORDER_RED);
  return (
    <Button
      onClick={() => {
        if (linkTarget.type === 'campaignLines') {
          reveal(Number.parseInt(linkTarget.id, 10)); // Unfold any accordions the line might be hidden behind
          setTimeout(highlight, 500, id);
        } else {
          highlight(id);
        }
      }}
      color="link"
    >
      {path}
    </Button>
  );
}

function ValidationErrors({ errors, reveal }) {
  const pairs = linearize(errors);
  return (
    <Table className="table-borderless">
      <tbody>
        {pairs.map(({ path, message, linkTarget }) => (
          <tr key={path}>
            <td>{scrollAnchor(path, linkTarget, reveal)}</td>
            <td>{message}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

ValidationErrors.propTypes = {
  errors: object.isRequired, // eslint-disable-line react/forbid-prop-types
  reveal: func.isRequired,
};

export { ValidationErrors };
export default connect(null, { reveal: revealLine })(ValidationErrors);
